import { formatDate } from "../../../../utils/general/generalUtils"

export interface IDnoSolarNotification {
    notificationId: string
    address: string
    postCode: string
    device: string
    status: string
    createdDate: string
    registeredCapacity?: number | null
    name?: string | null
    email?: string | null
    mpan?: string | null
    exportMpan?: string | null
}

export interface IDnoSolarNotificationsSearchResult {
    notifications: IDnoSolarNotification[]
    downloadData: unknown[]
    lastEvaluatedKey?: Record<string, string> | null
}

const ensureString = (value: unknown): string =>
    typeof value === "string" ? value : ""

const ensureNullableString = (value: unknown): string | null =>
    typeof value === "string" ? value : null

const ensureNullableNumber = (value: unknown): number | null =>
    typeof value === "number" && Number.isFinite(value) ? value : null

const ensureName = (firstName: unknown, lastName: unknown): string | null => {
    const first = ensureNullableString(firstName)?.trim() || ""
    const last = ensureNullableString(lastName)?.trim() || ""
    return `${first} ${last}`.trim() || null
}

const mapNotification = (
    notification: Record<string, unknown>
): IDnoSolarNotification => ({
    notificationId: ensureString(notification.notificationId),
    address: ensureString(notification.mainAddress),
    postCode: ensureString(notification.postCode),
    device: ensureString(notification.deviceRef),
    status: ensureString(notification.status),
    createdDate: formatDate(notification.createdDate),
    registeredCapacity: ensureNullableNumber(notification.registeredCapacity),
    name: ensureName(notification.firstName, notification.lastName),
    email: ensureNullableString(notification.email),
    mpan: ensureNullableString(notification.mpan),
    exportMpan: ensureNullableString(notification.exportMpan),
})

export const dnoSolarNotificationsMapper = {
    mapList: (response: unknown): IDnoSolarNotificationsSearchResult => {
        const guardedResponse = response as Record<string, unknown>
        if (!Array.isArray(guardedResponse.notifications)) {
            throw Error()
        }

        const notifications = guardedResponse.notifications.map((item) =>
            mapNotification(item as Record<string, unknown>)
        )

        return {
            notifications,
            downloadData: guardedResponse.notifications,
            lastEvaluatedKey:
                (guardedResponse.lastEvaluatedKey as Record<
                    string,
                    string
                > | null) || null,
        }
    },
}
